import {TextStyle, ViewStyle} from 'react-native';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import Styles from 'src/components/Styles';

export function getStyleDescriptor(): {
  [index: string]: ViewStyle & TextStyle;
} {
  return {
    container: {
      flexDirection: 'row',
      marginHorizontal: Styles.Spacing.m3,
      marginBottom: Styles.Spacing.m3,
      marginTop: Styles.Spacing.m2,
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: Styles.Spacing.m3,
      borderRadius: Styles.Spacing.m2,
      backgroundColor: '#fff',
      ...getLayoutDescriber().shadowStyles().shadow,
    },
    iconView: {
      width: Styles.Spacing.m4,
      borderRadius: Styles.Spacing.m2,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: Styles.primaryColor,
      height: Styles.Spacing.m4,
    },
    headerView: {
      justifyContent: 'flex-start',
      height: Styles.Heights.h4,
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: Styles.Spacing.m2,
    },
    snackButton: {
      marginBottom: Styles.Spacing.m2 + Styles.Spacing.m1,
      marginTop: Styles.Spacing.m3 + Styles.Spacing.m1,
      borderWidth: 1,
    },

    titleText: {
      marginLeft: Styles.Spacing.m3,
      color: Styles.darkColor,
      fontSize: Styles.Fonts.headerFont,
      fontWeight: '600',
    },
    snackDescriptionText: {
      color: Styles.darkColor,
      textAlign: 'left',
      fontSize: Styles.Fonts.sectionHeader,
      fontWeight: '400',
      marginVertical: Styles.Spacing.m1,
    },

    snackButtonText: {
      fontSize: Styles.Fonts.f7,
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '600',
    },
    revolveButtonStyle: {
      fontSize: Styles.Fonts.f7,
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '600',
    },

    label: {
      color: Styles.darkColor,
      fontSize: Styles.Fonts.f1,
    },
    cardNumber: {
      fontSize: Styles.Fonts.f1,
      color: Styles.lightGray,
    },
    revolveAddTxt: {
      color: Styles.black,
      fontWeight: '400',
      fontSize: 18,
    },
    starIconView: {
      alignItems: 'center',
      flexDirection: 'row',
      flex: 1,
    },
    revolveMainTxt: {
      fontWeight: '700',
      fontSize: 18,
      color: Styles.black,
      fontFamily: Styles.FontFamily.comodoVintage,
    },
  };
}

export default {
  getStyleDescriptor,
};
